import { apiClient } from '../fetch.ts';
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Bend Bike Rides
 * API service for the Bend Bike Rides application and clients.
 * OpenAPI spec version: 1.0.0
 */
import { action, query } from '../wrappers.ts';
import type {
	DeleteV0GroupGroupIdBody,
	DeleteV0GroupGroupIdEventSeriesIdBody,
	DeleteV0GroupGroupIdEventSeriesIdEventIdBody,
	DeleteV0UserMeAuthIdBody,
	DeleteV0UserMeAvatar200,
	DeleteV0UserMeBody,
	DeleteV0UserMeOauthProviderIdBody,
	GetHealth200,
	GetV0AreaClosure200,
	GetV0AreaClosureId200,
	GetV0AreaClosureParams,
	GetV0AreaClosureSearch200,
	GetV0AreaClosureSearchParams,
	GetV0AuthRegisterPasskey200,
	GetV0AuthRegisterPasskeyParams,
	GetV0Challenge200,
	GetV0ChallengeChallengeId200,
	GetV0ChallengeChallengeIdAttempts200,
	GetV0ChallengeChallengeIdAttemptsParams,
	GetV0ChallengeChallengeIdAttemptsUserId200,
	GetV0ChallengeChallengeIdAttemptsUserIdParams,
	GetV0ChallengeParams,
	GetV0Complex200,
	GetV0ComplexParams,
	GetV0ComplexSlug200,
	GetV0Event200,
	GetV0EventCalendarParams,
	GetV0EventParams,
	GetV0Group200,
	GetV0GroupGroupId200,
	GetV0GroupGroupIdEventSeriesId200,
	GetV0GroupGroupIdEventSeriesIdCalendarParams,
	GetV0GroupGroupIdEventSeriesIdParams,
	GetV0GroupGroupIdInvitation200,
	GetV0GroupGroupIdMembers200,
	GetV0GroupGroupIdRoute200,
	GetV0GroupParams,
	GetV0LocationReverse200,
	GetV0LocationReverseParams,
	GetV0LocationSuggest200,
	GetV0LocationSuggestId200,
	GetV0LocationSuggestParams,
	GetV0Poi200,
	GetV0PoiParams,
	GetV0PoiSearch200,
	GetV0PoiSearchParams,
	GetV0PoiSlug200,
	GetV0Post200,
	GetV0PostParams,
	GetV0PostPostSlug200,
	GetV0Route200,
	GetV0RouteParams,
	GetV0RouteRouteId200,
	GetV0Search200,
	GetV0SearchParams,
	GetV0Segment200,
	GetV0SegmentParams,
	GetV0SegmentSearch200,
	GetV0SegmentSearchParams,
	GetV0SegmentSegmentId200,
	GetV0Session200,
	GetV0Trail200,
	GetV0TrailAll200,
	GetV0TrailAllParams,
	GetV0TrailElvCounter200,
	GetV0TrailParams,
	GetV0TrailSearch200,
	GetV0TrailSearchParams,
	GetV0TrailSlug200,
	GetV0TrailSlugClosure200,
	GetV0User200,
	GetV0UserInvitation200,
	GetV0UserInvitationParams,
	GetV0UserMe200,
	GetV0UserMeAuth200,
	GetV0UserMeOauthUrl200,
	GetV0UserMeOauthUrlParams,
	GetV0UserMeSession200,
	GetV0UserParams,
	GetV0WebhookStrava200,
	GetV0WebhookStravaParams,
	PatchV0AreaClosureId200,
	PatchV0AreaClosureIdBody,
	PatchV0AuthForgotPasswordBody,
	PatchV0ChallengeChallengeId200,
	PatchV0ChallengeChallengeIdBody,
	PatchV0ComplexSlug200,
	PatchV0ComplexSlugBody,
	PatchV0GroupGroupId200,
	PatchV0GroupGroupIdBody,
	PatchV0GroupGroupIdEventSeriesId200,
	PatchV0GroupGroupIdEventSeriesIdBody,
	PatchV0GroupGroupIdEventSeriesIdEventId200,
	PatchV0GroupGroupIdEventSeriesIdEventIdBody,
	PatchV0GroupGroupIdInvitationInvitationId200,
	PatchV0GroupGroupIdMembersMemberId200,
	PatchV0GroupGroupIdMembersMemberIdBody,
	PatchV0MailingList200,
	PatchV0MailingListBody,
	PatchV0PoiSlug200,
	PatchV0PoiSlugBody,
	PatchV0PostPostId200,
	PatchV0PostPostIdBody,
	PatchV0SegmentSegmentId200,
	PatchV0SegmentSegmentIdBody,
	PatchV0TrailSlug200,
	PatchV0TrailSlugBody,
	PatchV0TrailSlugClosureIdBody,
	PatchV0UserInvitationId200,
	PatchV0UserMeAuth200,
	PatchV0UserMeAuthBody,
	PatchV0UserMeBody,
	PatchV0UserMeEmail200,
	PatchV0UserMeEmailBody,
	PatchV0UserMePassword200,
	PatchV0UserMePasswordBody,
	PostV0AreaClosure200,
	PostV0AreaClosureBody,
	PostV0AuthForgotPassword200,
	PostV0AuthForgotPasswordBody,
	PostV0AuthLogin202,
	PostV0AuthLoginBody,
	PostV0AuthPasskeyBody,
	PostV0AuthRegister200,
	PostV0AuthRegisterBody,
	PostV0AuthTotpBody,
	PostV0Challenge200,
	PostV0ChallengeBody,
	PostV0Group200,
	PostV0GroupBody,
	PostV0GroupGroupIdEvent201,
	PostV0GroupGroupIdEventBody,
	PostV0GroupGroupIdEventSeriesId201,
	PostV0GroupGroupIdEventSeriesIdBody,
	PostV0GroupGroupIdInvitation201,
	PostV0GroupGroupIdInvitationAcceptBody,
	PostV0GroupGroupIdInvitationBody,
	PostV0GroupGroupIdRoute200,
	PostV0GroupGroupIdRouteBody,
	PostV0MailingList200,
	PostV0MailingListBody,
	PostV0Poi200,
	PostV0PoiBody,
	PostV0Post200,
	PostV0PostBody,
	PostV0Segment200,
	PostV0SegmentBody,
	PostV0Trail200,
	PostV0TrailBody,
	PostV0TrailElvCounter200,
	PostV0TrailElvCounterBody,
	PostV0TrailSlugClosure200,
	PostV0TrailSlugClosureBody,
	PostV0TrailSlugConditions200,
	PostV0TrailSlugConditionsBody,
	PostV0TrailSlugMap201,
	PostV0TrailSlugMapBody,
	PostV0UserInvitationBody,
	PostV0UserMeAuth200,
	PostV0UserMeAuthBody,
	PostV0UserMeAvatar201,
	PostV0UserMeAvatarBody,
	PostV0UserMeEmail200,
	PostV0UserMeEmailBody,
	PostV0UserMeOauthCallback200,
	PostV0UserMeOauthCallbackBody,
	PostV0WebhookStravaBody,
	PutV0UserMeAvatar200,
	PutV0UserMeAvatarBody,
} from './bendBikeRides.schemas.ts';

/**
 * Cache Invalidation:
 *
 * Each query provides .key and .keyFor() for cache invalidation.
 *
 * Examples:
 *   // Invalidate all calls to a query
 *   revalidate(BendBikeRides.listPets.key);
 *
 *   // Invalidate a specific call with arguments
 *   revalidate(BendBikeRides.showPetById.keyFor("pet-123", 1));
 *
 *   // Invalidate multiple queries
 *   revalidate([BendBikeRides.listPets.key, BendBikeRides.showPetById.keyFor("pet-123", 1)]);
 */

/**
 * Check the health of the Bend Bike Rides service.
 * @summary Health
 */
export const getHealth = query(async () => {
	return apiClient<GetHealth200>({
		url: `/_/health`,
		method: 'GET',
	});
}, 'getHealth');

/**
 * Generic disallow.
 * @summary robots.txt
 */
export const getRobotsTxt = query(async () => {
	return apiClient<unknown>({
		url: `/robots.txt`,
		method: 'GET',
	});
}, 'getRobotsTxt');

/**
 * Create a new Area Closure
 * @summary Create Area Closure
 */
export const postV0AreaClosure = action(async (postV0AreaClosureBody: PostV0AreaClosureBody) => {
	return apiClient<PostV0AreaClosure200>({
		url: `/v0/area-closure`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0AreaClosureBody,
	});
}, 'postV0AreaClosure');

/**
 * List all Closures
 * @summary List Area Closures
 */
export const getV0AreaClosure = query(async (params?: GetV0AreaClosureParams) => {
	return apiClient<GetV0AreaClosure200>({
		url: `/v0/area-closure`,
		method: 'GET',
		params,
	});
}, 'getV0AreaClosure');

/**
 * Search through all Closures using a query
 * @summary Search Area Closures
 */
export const getV0AreaClosureSearch = query(async (params: GetV0AreaClosureSearchParams) => {
	return apiClient<GetV0AreaClosureSearch200>({
		url: `/v0/area-closure/search`,
		method: 'GET',
		params,
	});
}, 'getV0AreaClosureSearch');

/**
 * Delete an Area Closure by ID
 * @summary Delete Area Closure
 */
export const deleteV0AreaClosureId = action(async (id: string) => {
	return apiClient<null>({
		url: `/v0/area-closure/${id}`,
		method: 'DELETE',
	});
}, 'deleteV0AreaClosureId');

/**
 * Update an Area Closure
 * @summary Update Area Closure
 */
export const patchV0AreaClosureId = action(async (id: string, patchV0AreaClosureIdBody: PatchV0AreaClosureIdBody) => {
	return apiClient<PatchV0AreaClosureId200>({
		url: `/v0/area-closure/${id}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0AreaClosureIdBody,
	});
}, 'patchV0AreaClosureId');

/**
 * Get an Area Closure by ID
 * @summary Get Area Closure
 */
export const getV0AreaClosureId = query(async (id: string) => {
	return apiClient<GetV0AreaClosureId200>({
		url: `/v0/area-closure/${id}`,
		method: 'GET',
	});
}, 'getV0AreaClosureId');

/**
 * Request a password reset code
 * @summary Forgot Password
 */
export const postV0AuthForgotPassword = action(async (postV0AuthForgotPasswordBody: PostV0AuthForgotPasswordBody) => {
	return apiClient<PostV0AuthForgotPassword200>({
		url: `/v0/auth/forgot-password`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0AuthForgotPasswordBody,
	});
}, 'postV0AuthForgotPassword');

/**
 * Updates a password using a code
 * @summary Reset Password
 */
export const patchV0AuthForgotPassword = action(
	async (patchV0AuthForgotPasswordBody: PatchV0AuthForgotPasswordBody) => {
		return apiClient<null>({
			url: `/v0/auth/forgot-password`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: patchV0AuthForgotPasswordBody,
		});
	},
	'patchV0AuthForgotPassword',
);

/**
 * Log in to the backend service.
 * @summary Log in
 */
export const postV0AuthLogin = action(async (postV0AuthLoginBody: PostV0AuthLoginBody) => {
	return apiClient<PostV0AuthLogin202 | null>({
		url: `/v0/auth/login`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0AuthLoginBody,
	});
}, 'postV0AuthLogin');

/**
 * Log out of the backend service.
 * @summary Log out
 */
export const postV0AuthLogout = action(async () => {
	return apiClient<null>({
		url: `/v0/auth/logout`,
		method: 'POST',
	});
}, 'postV0AuthLogout');

/**
 * Log in with AuthN credentials.
 * @summary Submit MFA code
 */
export const postV0AuthPasskey = action(async (postV0AuthPasskeyBody: PostV0AuthPasskeyBody) => {
	return apiClient<null>({
		url: `/v0/auth/passkey`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0AuthPasskeyBody,
	});
}, 'postV0AuthPasskey');

/**
 * Generate WebAuthN registration options
 * @summary Get AuthN registration options
 */
export const getV0AuthRegisterPasskey = query(async (params: GetV0AuthRegisterPasskeyParams) => {
	return apiClient<GetV0AuthRegisterPasskey200>({
		url: `/v0/auth/register/passkey`,
		method: 'GET',
		params,
	});
}, 'getV0AuthRegisterPasskey');

/**
 * Sign up a new user account.
 * @summary Sign up
 */
export const postV0AuthRegister = action(async (postV0AuthRegisterBody: PostV0AuthRegisterBody) => {
	return apiClient<PostV0AuthRegister200>({
		url: `/v0/auth/register`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0AuthRegisterBody,
	});
}, 'postV0AuthRegister');

/**
 * Finish a login with a required TOTP code.
 * @summary Submit TOTP code
 */
export const postV0AuthTotp = action(async (postV0AuthTotpBody: PostV0AuthTotpBody) => {
	return apiClient<null>({
		url: `/v0/auth/totp`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0AuthTotpBody,
	});
}, 'postV0AuthTotp');

/**
 * Create a "segment of the week" challenge.
 * @summary Create challenge
 */
export const postV0Challenge = action(async (postV0ChallengeBody: PostV0ChallengeBody) => {
	return apiClient<PostV0Challenge200>({
		url: `/v0/challenge`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0ChallengeBody,
	});
}, 'postV0Challenge');

/**
 * List challenges.
 * @summary List challenges
 */
export const getV0Challenge = query(async (params?: GetV0ChallengeParams) => {
	return apiClient<GetV0Challenge200>({
		url: `/v0/challenge`,
		method: 'GET',
		params,
	});
}, 'getV0Challenge');

/**
 * Delete challenge by ID.
 * @summary Delete challenge
 */
export const deleteV0ChallengeChallengeId = action(async (challengeId: string) => {
	return apiClient<null>({
		url: `/v0/challenge/${challengeId}`,
		method: 'DELETE',
	});
}, 'deleteV0ChallengeChallengeId');

/**
 * Get challenge by ID.
 * @summary Get challenge
 */
export const getV0ChallengeChallengeId = query(async (challengeId: string) => {
	return apiClient<GetV0ChallengeChallengeId200>({
		url: `/v0/challenge/${challengeId}`,
		method: 'GET',
	});
}, 'getV0ChallengeChallengeId');

/**
 * Update "segment of the week" challenge.
 * @summary Update challenge
 */
export const patchV0ChallengeChallengeId = action(
	async (challengeId: string, patchV0ChallengeChallengeIdBody: PatchV0ChallengeChallengeIdBody) => {
		return apiClient<PatchV0ChallengeChallengeId200>({
			url: `/v0/challenge/${challengeId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: patchV0ChallengeChallengeIdBody,
		});
	},
	'patchV0ChallengeChallengeId',
);

/**
 * List all attempts for a challenge.
 * @summary List challenge attempts
 */
export const getV0ChallengeChallengeIdAttempts = query(
	async (challengeId: string, params?: GetV0ChallengeChallengeIdAttemptsParams) => {
		return apiClient<GetV0ChallengeChallengeIdAttempts200>({
			url: `/v0/challenge/${challengeId}/attempts`,
			method: 'GET',
			params,
		});
	},
	'getV0ChallengeChallengeIdAttempts',
);

/**
 * List all attempts for a challenge for a given userId.
 * @summary List challenge attempts by user
 */
export const getV0ChallengeChallengeIdAttemptsUserId = query(
	async (challengeId: string, userId: string, params?: GetV0ChallengeChallengeIdAttemptsUserIdParams) => {
		return apiClient<GetV0ChallengeChallengeIdAttemptsUserId200>({
			url: `/v0/challenge/${challengeId}/attempts/${userId}`,
			method: 'GET',
			params,
		});
	},
	'getV0ChallengeChallengeIdAttemptsUserId',
);

/**
 * Get complexes and their associated trails.
 * @summary List Complexes
 */
export const getV0Complex = query(async (params?: GetV0ComplexParams) => {
	return apiClient<GetV0Complex200>({
		url: `/v0/complex`,
		method: 'GET',
		params,
	});
}, 'getV0Complex');

/**
 * Update a new Complex
 * @summary Update Complex
 */
export const patchV0ComplexSlug = action(async (slug: string, patchV0ComplexSlugBody: PatchV0ComplexSlugBody) => {
	return apiClient<PatchV0ComplexSlug200>({
		url: `/v0/complex/${slug}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0ComplexSlugBody,
	});
}, 'patchV0ComplexSlug');

/**
 * Get Complex by slug
 * @summary Get Complexs
 */
export const getV0ComplexSlug = query(async (slug: string) => {
	return apiClient<GetV0ComplexSlug200>({
		url: `/v0/complex/${slug}`,
		method: 'GET',
	});
}, 'getV0ComplexSlug');

/**
 * Get ICS for events
 * @summary Get Event Calendar ICS
 */
export const getV0EventCalendar = query(async (params?: GetV0EventCalendarParams) => {
	return apiClient<string>({
		url: `/v0/event/calendar`,
		method: 'GET',
		params,
	});
}, 'getV0EventCalendar');

/**
 * List events between dates (inclusive)
 * @summary List events
 */
export const getV0Event = query(async (params?: GetV0EventParams) => {
	return apiClient<GetV0Event200>({
		url: `/v0/event`,
		method: 'GET',
		params,
	});
}, 'getV0Event');

/**
 * Create a new group.
 * @summary Create a Group
 */
export const postV0Group = action(async (postV0GroupBody: PostV0GroupBody) => {
	return apiClient<PostV0Group200>({
		url: `/v0/group`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0GroupBody,
	});
}, 'postV0Group');

/**
 * List all groups
 * @summary List Groups
 */
export const getV0Group = query(async (params?: GetV0GroupParams) => {
	return apiClient<GetV0Group200>({
		url: `/v0/group`,
		method: 'GET',
		params,
	});
}, 'getV0Group');

/**
 * Get a group by slug
 * @summary Delete a Group
 */
export const deleteV0GroupGroupId = action(
	async (groupId: string, deleteV0GroupGroupIdBody: DeleteV0GroupGroupIdBody) => {
		return apiClient<null>({
			url: `/v0/group/${groupId}`,
			method: 'DELETE',
			headers: { 'Content-Type': 'application/json' },
			data: deleteV0GroupGroupIdBody,
		});
	},
	'deleteV0GroupGroupId',
);

/**
 * Get a group by slug
 * @summary Get a Group
 */
export const getV0GroupGroupId = query(async (groupId: string) => {
	return apiClient<GetV0GroupGroupId200>({
		url: `/v0/group/${groupId}`,
		method: 'GET',
	});
}, 'getV0GroupGroupId');

/**
 * Update a group’s information
 * @summary Update a Group
 */
export const patchV0GroupGroupId = action(async (groupId: string, patchV0GroupGroupIdBody: PatchV0GroupGroupIdBody) => {
	return apiClient<PatchV0GroupGroupId200>({
		url: `/v0/group/${groupId}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0GroupGroupIdBody,
	});
}, 'patchV0GroupGroupId');

/**
 * Create an event series and at least one event
 * @summary Create series
 */
export const postV0GroupGroupIdEvent = action(
	async (groupId: string, postV0GroupGroupIdEventBody: PostV0GroupGroupIdEventBody) => {
		return apiClient<PostV0GroupGroupIdEvent201>({
			url: `/v0/group/${groupId}/event`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postV0GroupGroupIdEventBody,
		});
	},
	'postV0GroupGroupIdEvent',
);

/**
 * Get an event as an ICS
 * @summary Get Event ICS
 */
export const getV0GroupGroupIdEventSeriesIdCalendar = query(
	async (groupId: string, seriesId: string, params?: GetV0GroupGroupIdEventSeriesIdCalendarParams) => {
		return apiClient<string>({
			url: `/v0/group/${groupId}/event/${seriesId}/calendar`,
			method: 'GET',
			params,
		});
	},
	'getV0GroupGroupIdEventSeriesIdCalendar',
);

/**
 * Create a new event in a series
 * @summary Create event
 */
export const postV0GroupGroupIdEventSeriesId = action(
	async (
		groupId: string,
		seriesId: string,
		postV0GroupGroupIdEventSeriesIdBody: PostV0GroupGroupIdEventSeriesIdBody,
	) => {
		return apiClient<PostV0GroupGroupIdEventSeriesId201>({
			url: `/v0/group/${groupId}/event/${seriesId}`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postV0GroupGroupIdEventSeriesIdBody,
		});
	},
	'postV0GroupGroupIdEventSeriesId',
);

/**
 * Delete an entire event series and its events. This is permanent and cannot be undone.
 * @summary Delete series
 */
export const deleteV0GroupGroupIdEventSeriesId = action(
	async (
		groupId: string,
		seriesId: string,
		deleteV0GroupGroupIdEventSeriesIdBody: DeleteV0GroupGroupIdEventSeriesIdBody,
	) => {
		return apiClient<null>({
			url: `/v0/group/${groupId}/event/${seriesId}`,
			method: 'DELETE',
			headers: { 'Content-Type': 'application/json' },
			data: deleteV0GroupGroupIdEventSeriesIdBody,
		});
	},
	'deleteV0GroupGroupIdEventSeriesId',
);

/**
 * Get an event series by group & series slug. Optionally pass a timestamp to get only the event(s) at that timestamp.
 * @summary Get series
 */
export const getV0GroupGroupIdEventSeriesId = query(
	async (groupId: string, seriesId: string, params?: GetV0GroupGroupIdEventSeriesIdParams) => {
		return apiClient<GetV0GroupGroupIdEventSeriesId200>({
			url: `/v0/group/${groupId}/event/${seriesId}`,
			method: 'GET',
			params,
		});
	},
	'getV0GroupGroupIdEventSeriesId',
);

/**
 * Allows updating an event series
 * @summary Update series
 */
export const patchV0GroupGroupIdEventSeriesId = action(
	async (
		groupId: string,
		seriesId: string,
		patchV0GroupGroupIdEventSeriesIdBody: PatchV0GroupGroupIdEventSeriesIdBody,
	) => {
		return apiClient<PatchV0GroupGroupIdEventSeriesId200>({
			url: `/v0/group/${groupId}/event/${seriesId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: patchV0GroupGroupIdEventSeriesIdBody,
		});
	},
	'patchV0GroupGroupIdEventSeriesId',
);

/**
 * Delete a single event from a series. This is permanent and cannot be undone.
 * @summary Delete event
 */
export const deleteV0GroupGroupIdEventSeriesIdEventId = action(
	async (
		groupId: string,
		seriesId: string,
		eventId: string,
		deleteV0GroupGroupIdEventSeriesIdEventIdBody: DeleteV0GroupGroupIdEventSeriesIdEventIdBody,
	) => {
		return apiClient<null>({
			url: `/v0/group/${groupId}/event/${seriesId}/${eventId}`,
			method: 'DELETE',
			headers: { 'Content-Type': 'application/json' },
			data: deleteV0GroupGroupIdEventSeriesIdEventIdBody,
		});
	},
	'deleteV0GroupGroupIdEventSeriesIdEventId',
);

/**
 * Allows updating an event
 * @summary Update event
 */
export const patchV0GroupGroupIdEventSeriesIdEventId = action(
	async (
		groupId: string,
		seriesId: string,
		eventId: string,
		patchV0GroupGroupIdEventSeriesIdEventIdBody: PatchV0GroupGroupIdEventSeriesIdEventIdBody,
	) => {
		return apiClient<PatchV0GroupGroupIdEventSeriesIdEventId200>({
			url: `/v0/group/${groupId}/event/${seriesId}/${eventId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: patchV0GroupGroupIdEventSeriesIdEventIdBody,
		});
	},
	'patchV0GroupGroupIdEventSeriesIdEventId',
);

/**
 * Existing users can use this endpoint to accept an invitation, assuming their email address and invitation code match the group.
 * @summary Accept group invitation
 */
export const postV0GroupGroupIdInvitationAccept = action(
	async (groupId: string, postV0GroupGroupIdInvitationAcceptBody: PostV0GroupGroupIdInvitationAcceptBody) => {
		return apiClient<null>({
			url: `/v0/group/${groupId}/invitation/accept`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postV0GroupGroupIdInvitationAcceptBody,
		});
	},
	'postV0GroupGroupIdInvitationAccept',
);

/**
 * Group members with the `invite_user` permission can invite more users.
 * @summary Invite a group member
 */
export const postV0GroupGroupIdInvitation = action(
	async (groupId: string, postV0GroupGroupIdInvitationBody: PostV0GroupGroupIdInvitationBody) => {
		return apiClient<PostV0GroupGroupIdInvitation201>({
			url: `/v0/group/${groupId}/invitation`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postV0GroupGroupIdInvitationBody,
		});
	},
	'postV0GroupGroupIdInvitation',
);

/**
 * List all open & unaccepted invitations.
 * @summary List group invitations
 */
export const getV0GroupGroupIdInvitation = query(async (groupId: string) => {
	return apiClient<GetV0GroupGroupIdInvitation200>({
		url: `/v0/group/${groupId}/invitation`,
		method: 'GET',
	});
}, 'getV0GroupGroupIdInvitation');

/**
 * Extends the expiration of the invitation and re-sends the event for emailing a code.
 * @summary Resend a group invitation
 */
export const patchV0GroupGroupIdInvitationInvitationId = action(async (groupId: string, invitationId: string) => {
	return apiClient<PatchV0GroupGroupIdInvitationInvitationId200>({
		url: `/v0/group/${groupId}/invitation/${invitationId}`,
		method: 'PATCH',
	});
}, 'patchV0GroupGroupIdInvitationInvitationId');

/**
 * Un-invite a group member that has not yet accepted.
 * @summary Revoke a group invitation
 */
export const deleteV0GroupGroupIdInvitationInvitationId = action(async (groupId: string, invitationId: string) => {
	return apiClient<null>({
		url: `/v0/group/${groupId}/invitation/${invitationId}`,
		method: 'DELETE',
	});
}, 'deleteV0GroupGroupIdInvitationInvitationId');

/**
 * Get a group’s members with emails and permissions
 * @summary Get a Group’s members
 */
export const getV0GroupGroupIdMembers = query(async (groupId: string) => {
	return apiClient<GetV0GroupGroupIdMembers200>({
		url: `/v0/group/${groupId}/members`,
		method: 'GET',
	});
}, 'getV0GroupGroupIdMembers');

/**
 * Updates a group member’s permissions
 * @summary Update a group member
 */
export const patchV0GroupGroupIdMembersMemberId = action(
	async (
		groupId: string,
		memberId: string,
		patchV0GroupGroupIdMembersMemberIdBody: PatchV0GroupGroupIdMembersMemberIdBody,
	) => {
		return apiClient<PatchV0GroupGroupIdMembersMemberId200>({
			url: `/v0/group/${groupId}/members/${memberId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: patchV0GroupGroupIdMembersMemberIdBody,
		});
	},
	'patchV0GroupGroupIdMembersMemberId',
);

/**
 * Remove someone from a group
 * @summary Remove group member
 */
export const deleteV0GroupGroupIdMembersMemberId = action(async (groupId: string, memberId: string) => {
	return apiClient<null>({
		url: `/v0/group/${groupId}/members/${memberId}`,
		method: 'DELETE',
	});
}, 'deleteV0GroupGroupIdMembersMemberId');

/**
 * Upload a new route
 * @summary Add route
 */
export const postV0GroupGroupIdRoute = action(
	async (groupId: string, postV0GroupGroupIdRouteBody: PostV0GroupGroupIdRouteBody) => {
		return apiClient<PostV0GroupGroupIdRoute200>({
			url: `/v0/group/${groupId}/route`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postV0GroupGroupIdRouteBody,
		});
	},
	'postV0GroupGroupIdRoute',
);

/**
 * List available routes for a group
 * @summary List routes
 */
export const getV0GroupGroupIdRoute = query(async (groupId: string) => {
	return apiClient<GetV0GroupGroupIdRoute200>({
		url: `/v0/group/${groupId}/route`,
		method: 'GET',
	});
}, 'getV0GroupGroupIdRoute');

/**
 * Delete a single route by ID
 * @summary Delete a route
 */
export const deleteV0GroupGroupIdRouteRouteId = action(async (groupId: string, routeId: string) => {
	return apiClient<null>({
		url: `/v0/group/${groupId}/route/${routeId}`,
		method: 'DELETE',
	});
}, 'deleteV0GroupGroupIdRouteRouteId');

/**
 * Get locations from latitude/longitude
 * @summary Reverse lookup locations
 */
export const getV0LocationReverse = query(async (params: GetV0LocationReverseParams) => {
	return apiClient<GetV0LocationReverse200>({
		url: `/v0/location/reverse`,
		method: 'GET',
		params,
	});
}, 'getV0LocationReverse');

/**
 * Freeform location search
 * @summary Suggest locations
 */
export const getV0LocationSuggest = query(async (params: GetV0LocationSuggestParams) => {
	return apiClient<GetV0LocationSuggest200>({
		url: `/v0/location/suggest`,
		method: 'GET',
		params,
	});
}, 'getV0LocationSuggest');

/**
 * Get location details from a mapbox ID. This should be called after a location is selected from the suggest locations endpoint.
 * @summary Retrieve location
 */
export const getV0LocationSuggestId = query(async (id: string) => {
	return apiClient<GetV0LocationSuggestId200>({
		url: `/v0/location/suggest/${id}`,
		method: 'GET',
	});
}, 'getV0LocationSuggestId');

/**
 * Subscribe to the mailing list.
 * @summary Subscribe
 */
export const postV0MailingList = action(async (postV0MailingListBody: PostV0MailingListBody) => {
	return apiClient<PostV0MailingList200>({
		url: `/v0/mailing-list`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0MailingListBody,
	});
}, 'postV0MailingList');

/**
 * Verify a subscription to the mailing list.
 * @summary Verify
 */
export const patchV0MailingList = action(async (patchV0MailingListBody: PatchV0MailingListBody) => {
	return apiClient<PatchV0MailingList200>({
		url: `/v0/mailing-list`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0MailingListBody,
	});
}, 'patchV0MailingList');

/**
 * Create a new POI
 * @summary Create POI
 */
export const postV0Poi = action(async (postV0PoiBody: PostV0PoiBody) => {
	return apiClient<PostV0Poi200>({
		url: `/v0/poi`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0PoiBody,
	});
}, 'postV0Poi');

/**
 * List all POIs
 * @summary List POIs
 */
export const getV0Poi = query(async (params?: GetV0PoiParams) => {
	return apiClient<GetV0Poi200>({
		url: `/v0/poi`,
		method: 'GET',
		params,
	});
}, 'getV0Poi');

/**
 * Search through all POIs using a query
 * @summary Search POIs
 */
export const getV0PoiSearch = query(async (params: GetV0PoiSearchParams) => {
	return apiClient<GetV0PoiSearch200>({
		url: `/v0/poi/search`,
		method: 'GET',
		params,
	});
}, 'getV0PoiSearch');

/**
 * Update a new POI
 * @summary Update POI
 */
export const patchV0PoiSlug = action(async (slug: string, patchV0PoiSlugBody: PatchV0PoiSlugBody) => {
	return apiClient<PatchV0PoiSlug200>({
		url: `/v0/poi/${slug}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0PoiSlugBody,
	});
}, 'patchV0PoiSlug');

/**
 * Get POI by slug
 * @summary Get POIs
 */
export const getV0PoiSlug = query(async (slug: string) => {
	return apiClient<GetV0PoiSlug200>({
		url: `/v0/poi/${slug}`,
		method: 'GET',
	});
}, 'getV0PoiSlug');

/**
 * Create a new post
 * @summary Create post
 */
export const postV0Post = action(async (postV0PostBody: PostV0PostBody) => {
	return apiClient<PostV0Post200>({
		url: `/v0/post`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0PostBody,
	});
}, 'postV0Post');

/**
 * List available posts
 * @summary List posts
 */
export const getV0Post = query(async (params?: GetV0PostParams) => {
	return apiClient<GetV0Post200>({
		url: `/v0/post`,
		method: 'GET',
		params,
	});
}, 'getV0Post');

/**
 * Delete a post
 * @summary Delete post
 */
export const deleteV0PostPostId = action(async (postId: string) => {
	return apiClient<null>({
		url: `/v0/post/${postId}`,
		method: 'DELETE',
	});
}, 'deleteV0PostPostId');

/**
 * Update a post by ID
 * @summary Update post
 */
export const patchV0PostPostId = action(async (postId: string, patchV0PostPostIdBody: PatchV0PostPostIdBody) => {
	return apiClient<PatchV0PostPostId200>({
		url: `/v0/post/${postId}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0PostPostIdBody,
	});
}, 'patchV0PostPostId');

/**
 * Get a post by slug
 * @summary Get post
 */
export const getV0PostPostSlug = query(async (postSlug: string) => {
	return apiClient<GetV0PostPostSlug200>({
		url: `/v0/post/${postSlug}`,
		method: 'GET',
	});
}, 'getV0PostPostSlug');

/**
 * List available routes
 * @summary List routes
 */
export const getV0Route = query(async (params: GetV0RouteParams) => {
	return apiClient<GetV0Route200>({
		url: `/v0/route`,
		method: 'GET',
		params,
	});
}, 'getV0Route');

/**
 * Get a single route by ID
 * @summary Get a route
 */
export const getV0RouteRouteId = query(async (routeId: string) => {
	return apiClient<GetV0RouteRouteId200>({
		url: `/v0/route/${routeId}`,
		method: 'GET',
	});
}, 'getV0RouteRouteId');

/**
 * Get a single route by ID as GPX file
 * @summary Get as GPX
 */
export const getV0RouteRouteIdGpx = query(async (routeId: string) => {
	return apiClient<unknown>({
		url: `/v0/route/${routeId}.gpx`,
		method: 'GET',
	});
}, 'getV0RouteRouteIdGpx');

/**
 * Searches across trails, complexes, and POIs using user input.
 * @summary Search all data
 */
export const getV0Search = query(async (params: GetV0SearchParams) => {
	return apiClient<GetV0Search200>({
		url: `/v0/search`,
		method: 'GET',
		params,
	});
}, 'getV0Search');

/**
 * Requests data from Strava and adds a vote.
 * @summary Request segment
 */
export const postV0Segment = action(async (postV0SegmentBody: PostV0SegmentBody) => {
	return apiClient<PostV0Segment200>({
		url: `/v0/segment`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0SegmentBody,
	});
}, 'postV0Segment');

/**
 * List segments already synced from Strava.
 * @summary List segments
 */
export const getV0Segment = query(async (params?: GetV0SegmentParams) => {
	return apiClient<GetV0Segment200>({
		url: `/v0/segment`,
		method: 'GET',
		params,
	});
}, 'getV0Segment');

/**
 * Search segments already synced from Strava.
 * @summary Search segments
 */
export const getV0SegmentSearch = query(async (params: GetV0SegmentSearchParams) => {
	return apiClient<GetV0SegmentSearch200>({
		url: `/v0/segment/search`,
		method: 'GET',
		params,
	});
}, 'getV0SegmentSearch');

/**
 * Get segment by ID.
 * @summary Get segment
 */
export const getV0SegmentSegmentId = query(async (segmentId: string) => {
	return apiClient<GetV0SegmentSegmentId200>({
		url: `/v0/segment/${segmentId}`,
		method: 'GET',
	});
}, 'getV0SegmentSegmentId');

/**
 * Update a Strava segment.
 * @summary Update segment
 */
export const patchV0SegmentSegmentId = action(
	async (segmentId: string, patchV0SegmentSegmentIdBody: PatchV0SegmentSegmentIdBody) => {
		return apiClient<PatchV0SegmentSegmentId200>({
			url: `/v0/segment/${segmentId}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: patchV0SegmentSegmentIdBody,
		});
	},
	'patchV0SegmentSegmentId',
);

/**
 * Get session information and feature flags.
 * @summary Session
 */
export const getV0Session = query(async () => {
	return apiClient<GetV0Session200>({
		url: `/v0/session`,
		method: 'GET',
	});
}, 'getV0Session');

/**
 * Create a new trail.
 * @summary Create Trail
 */
export const postV0Trail = action(async (postV0TrailBody: PostV0TrailBody) => {
	return apiClient<PostV0Trail200>({
		url: `/v0/trail`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0TrailBody,
	});
}, 'postV0Trail');

/**
 * Get trails.
 * @deprecated
 * @summary List Trails
 */
export const getV0Trail = query(async (params: GetV0TrailParams) => {
	return apiClient<GetV0Trail200>({
		url: `/v0/trail`,
		method: 'GET',
		params,
	});
}, 'getV0Trail');

/**
 * List all trails by type
 * @summary All trails
 */
export const getV0TrailAll = query(async (params?: GetV0TrailAllParams) => {
	return apiClient<GetV0TrailAll200>({
		url: `/v0/trail/all`,
		method: 'GET',
		params,
	});
}, 'getV0TrailAll');

/**
 * Search trails with a query
 * @summary Search trails
 */
export const getV0TrailSearch = query(async (params: GetV0TrailSearchParams) => {
	return apiClient<GetV0TrailSearch200>({
		url: `/v0/trail/search`,
		method: 'GET',
		params,
	});
}, 'getV0TrailSearch');

/**
 * Update a trail. Requires `trail_update` permissions.
 * @summary Update a Trail
 */
export const patchV0TrailSlug = action(async (slug: string, patchV0TrailSlugBody: PatchV0TrailSlugBody) => {
	return apiClient<PatchV0TrailSlug200>({
		url: `/v0/trail/${slug}`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0TrailSlugBody,
	});
}, 'patchV0TrailSlug');

/**
 * Get a trail by slug.
 * @summary Get Trail
 */
export const getV0TrailSlug = query(async (slug: string) => {
	return apiClient<GetV0TrailSlug200>({
		url: `/v0/trail/${slug}`,
		method: 'GET',
	});
}, 'getV0TrailSlug');

/**
 * Starts the process for updating a static trail map image. Returns a signed URL allowing upload.
 * @summary Start map update process
 */
export const postV0TrailSlugMap = action(async (slug: string, postV0TrailSlugMapBody: PostV0TrailSlugMapBody) => {
	return apiClient<PostV0TrailSlugMap201>({
		url: `/v0/trail/${slug}/map`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0TrailSlugMapBody,
	});
}, 'postV0TrailSlugMap');

/**
 * Create a trail closure. Requires `trail_update` permissions.
 * @summary Create a trail closure
 */
export const postV0TrailSlugClosure = action(
	async (slug: string, postV0TrailSlugClosureBody: PostV0TrailSlugClosureBody) => {
		return apiClient<PostV0TrailSlugClosure200>({
			url: `/v0/trail/${slug}/closure`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postV0TrailSlugClosureBody,
		});
	},
	'postV0TrailSlugClosure',
);

/**
 * List an individual trail’s closures.
 * @summary List trail closures
 */
export const getV0TrailSlugClosure = query(async (slug: string) => {
	return apiClient<GetV0TrailSlugClosure200>({
		url: `/v0/trail/${slug}/closure`,
		method: 'GET',
	});
}, 'getV0TrailSlugClosure');

/**
 * Edits a trail closure.
 * @summary Edit a trail closure
 */
export const patchV0TrailSlugClosureId = action(
	async (slug: string, id: string, patchV0TrailSlugClosureIdBody: PatchV0TrailSlugClosureIdBody) => {
		return apiClient<null>({
			url: `/v0/trail/${slug}/closure/${id}`,
			method: 'PATCH',
			headers: { 'Content-Type': 'application/json' },
			data: patchV0TrailSlugClosureIdBody,
		});
	},
	'patchV0TrailSlugClosureId',
);

/**
 * Deletes a trail closure. Only use this if one was created in error. Otherwise modify the start/end date appropriately
 * @summary Delete a trail closure
 */
export const deleteV0TrailSlugClosureId = action(async (slug: string, id: string) => {
	return apiClient<null>({
		url: `/v0/trail/${slug}/closure/${id}`,
		method: 'DELETE',
	});
}, 'deleteV0TrailSlugClosureId');

/**
 * Create a conditions report for a given trail.
 * @summary Create a conditions report
 */
export const postV0TrailSlugConditions = action(
	async (slug: string, postV0TrailSlugConditionsBody: PostV0TrailSlugConditionsBody) => {
		return apiClient<PostV0TrailSlugConditions200>({
			url: `/v0/trail/${slug}/conditions`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postV0TrailSlugConditionsBody,
		});
	},
	'postV0TrailSlugConditions',
);

/**
 * Post a new ELV count
 * @summary Post a new ELV counter
 */
export const postV0TrailElvCounter = action(async (postV0TrailElvCounterBody: PostV0TrailElvCounterBody) => {
	return apiClient<PostV0TrailElvCounter200>({
		url: `/v0/trail/elv/counter`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0TrailElvCounterBody,
	});
}, 'postV0TrailElvCounter');

/**
 * get the ELV counter
 * @summary Get the ELV counter
 */
export const getV0TrailElvCounter = query(async () => {
	return apiClient<GetV0TrailElvCounter200>({
		url: `/v0/trail/elv/counter`,
		method: 'GET',
	});
}, 'getV0TrailElvCounter');

/**
 * Get trails mvt source definition
 * @summary Trail MVT source
 */
export const getV0TrailVector = query(async () => {
	return apiClient<unknown>({
		url: `/v0/trail/vector`,
		method: 'GET',
	});
}, 'getV0TrailVector');

/**
 * Get trails as protobuf/mvt
 * @summary Trails as MVT
 */
export const getV0TrailVectorZXYPbf = query(async (z: string, x: string, y: string) => {
	return apiClient<unknown>({
		url: `/v0/trail/vector/${z}/${x}/${y}.pbf`,
		method: 'GET',
	});
}, 'getV0TrailVectorZXYPbf');

/**
 * Lists all users
 * @summary List users
 */
export const getV0User = query(async (params?: GetV0UserParams) => {
	return apiClient<GetV0User200>({
		url: `/v0/user`,
		method: 'GET',
		params,
	});
}, 'getV0User');

/**
 * Get the currently logged-in user.
 * @summary Logged-in User
 */
export const getV0UserMe = query(async () => {
	return apiClient<GetV0UserMe200>({
		url: `/v0/user/me`,
		method: 'GET',
	});
}, 'getV0UserMe');

/**
 * Update configurable user information and settings
 * @summary Update user
 */
export const patchV0UserMe = action(async (patchV0UserMeBody: PatchV0UserMeBody) => {
	return apiClient<null>({
		url: `/v0/user/me`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0UserMeBody,
	});
}, 'patchV0UserMe');

/**
 * Deletes the currently logged-in user account.
 * @summary Delete account
 */
export const deleteV0UserMe = action(async (deleteV0UserMeBody: DeleteV0UserMeBody) => {
	return apiClient<null>({
		url: `/v0/user/me`,
		method: 'DELETE',
		headers: { 'Content-Type': 'application/json' },
		data: deleteV0UserMeBody,
	});
}, 'deleteV0UserMe');

/**
 * First step for groups & events: an admin can invite a group creator by email address.
 * @summary Invite a group creator
 */
export const postV0UserInvitation = action(async (postV0UserInvitationBody: PostV0UserInvitationBody) => {
	return apiClient<null>({
		url: `/v0/user/invitation`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0UserInvitationBody,
	});
}, 'postV0UserInvitation');

/**
 * Lists all invitations
 * @summary List group creator invitations
 */
export const getV0UserInvitation = query(async (params?: GetV0UserInvitationParams) => {
	return apiClient<GetV0UserInvitation200>({
		url: `/v0/user/invitation`,
		method: 'GET',
		params,
	});
}, 'getV0UserInvitation');

/**
 * Extends the expiration of the invitation and re-sends the event for emailing a code.
 * @summary Resend an invitation
 */
export const patchV0UserInvitationId = action(async (id: string) => {
	return apiClient<PatchV0UserInvitationId200>({
		url: `/v0/user/invitation/${id}`,
		method: 'PATCH',
	});
}, 'patchV0UserInvitationId');

/**
 * You know… sometimes things happen.
 * @summary Revoke an invitation
 */
export const deleteV0UserInvitationId = action(async (id: string) => {
	return apiClient<null>({
		url: `/v0/user/invitation/${id}`,
		method: 'DELETE',
	});
}, 'deleteV0UserInvitationId');

/**
 * @summary Get auth info
 */
export const getV0UserMeAuth = query(async () => {
	return apiClient<GetV0UserMeAuth200>({
		url: `/v0/user/me/auth`,
		method: 'GET',
	});
}, 'getV0UserMeAuth');

/**
 * Initiate the process and receive WebAuthN registration options and shared secret codes for generating TOTPs.
 * @summary Initiate creation of a new authentication option
 */
export const postV0UserMeAuth = action(async (postV0UserMeAuthBody: PostV0UserMeAuthBody) => {
	return apiClient<PostV0UserMeAuth200>({
		url: `/v0/user/me/auth`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0UserMeAuthBody,
	});
}, 'postV0UserMeAuth');

/**
 * Verify a WebAuthN or TOTP challenge responses.
 * @summary Verify MFA registration
 */
export const patchV0UserMeAuth = action(async (patchV0UserMeAuthBody: PatchV0UserMeAuthBody) => {
	return apiClient<PatchV0UserMeAuth200>({
		url: `/v0/user/me/auth`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0UserMeAuthBody,
	});
}, 'patchV0UserMeAuth');

/**
 * Removes MFA security from the logged-in user account
 * @summary Delete the MFA token
 */
export const deleteV0UserMeAuthId = action(async (id: string, deleteV0UserMeAuthIdBody: DeleteV0UserMeAuthIdBody) => {
	return apiClient<null>({
		url: `/v0/user/me/auth/${id}`,
		method: 'DELETE',
		headers: { 'Content-Type': 'application/json' },
		data: deleteV0UserMeAuthIdBody,
	});
}, 'deleteV0UserMeAuthId');

/**
 * Gets a signed URL to upload an avatar
 * @summary Create avatar upload URL
 */
export const postV0UserMeAvatar = action(async (postV0UserMeAvatarBody: PostV0UserMeAvatarBody) => {
	return apiClient<PostV0UserMeAvatar201>({
		url: `/v0/user/me/avatar`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0UserMeAvatarBody,
	});
}, 'postV0UserMeAvatar');

/**
 * Replaces an avatar
 * @summary Replace avatar
 */
export const putV0UserMeAvatar = action(async (putV0UserMeAvatarBody: PutV0UserMeAvatarBody) => {
	return apiClient<PutV0UserMeAvatar200>({
		url: `/v0/user/me/avatar`,
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		data: putV0UserMeAvatarBody,
	});
}, 'putV0UserMeAvatar');

/**
 * Removes and resets the user’s avatar
 * @summary Delete avatar
 */
export const deleteV0UserMeAvatar = action(async () => {
	return apiClient<DeleteV0UserMeAvatar200>({
		url: `/v0/user/me/avatar`,
		method: 'DELETE',
	});
}, 'deleteV0UserMeAvatar');

/**
 * Change your email address. This will require verification before it can be completed.
 * @summary Update email address
 */
export const postV0UserMeEmail = action(async (postV0UserMeEmailBody: PostV0UserMeEmailBody) => {
	return apiClient<PostV0UserMeEmail200>({
		url: `/v0/user/me/email`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0UserMeEmailBody,
	});
}, 'postV0UserMeEmail');

/**
 * Update a user account email verification.
 * @summary Verify email address
 */
export const patchV0UserMeEmail = action(async (patchV0UserMeEmailBody: PatchV0UserMeEmailBody) => {
	return apiClient<PatchV0UserMeEmail200>({
		url: `/v0/user/me/email`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0UserMeEmailBody,
	});
}, 'patchV0UserMeEmail');

/**
 * Change the currently logged-in user’s password.
 * @summary Update password
 */
export const patchV0UserMePassword = action(async (patchV0UserMePasswordBody: PatchV0UserMePasswordBody) => {
	return apiClient<PatchV0UserMePassword200>({
		url: `/v0/user/me/password`,
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		data: patchV0UserMePasswordBody,
	});
}, 'patchV0UserMePassword');

/**
 * Get a full list of potentially open sessions.
 * @summary List user sessions
 */
export const getV0UserMeSession = query(async () => {
	return apiClient<GetV0UserMeSession200>({
		url: `/v0/user/me/session`,
		method: 'GET',
	});
}, 'getV0UserMeSession');

/**
 * Forcibly log out of all sessions.
 * @summary Destroy all sessions
 */
export const deleteV0UserMeSession = action(async () => {
	return apiClient<null>({
		url: `/v0/user/me/session`,
		method: 'DELETE',
	});
}, 'deleteV0UserMeSession');

/**
 * Disconnects from the provider and deletes the record.
 * @summary Delete OAuth connection
 */
export const deleteV0UserMeOauthProviderId = action(
	async (providerId: string, deleteV0UserMeOauthProviderIdBody: DeleteV0UserMeOauthProviderIdBody) => {
		return apiClient<null>({
			url: `/v0/user/me/oauth/${providerId}`,
			method: 'DELETE',
			headers: { 'Content-Type': 'application/json' },
			data: deleteV0UserMeOauthProviderIdBody,
		});
	},
	'deleteV0UserMeOauthProviderId',
);

/**
 * Receives an authorization code from a third-party OAuth application.
 * @summary Receive authorization code
 */
export const postV0UserMeOauthCallback = action(
	async (postV0UserMeOauthCallbackBody: PostV0UserMeOauthCallbackBody) => {
		return apiClient<PostV0UserMeOauthCallback200>({
			url: `/v0/user/me/oauth/callback`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: postV0UserMeOauthCallbackBody,
		});
	},
	'postV0UserMeOauthCallback',
);

/**
 * Get redirect URL to authorize with a third-party OAuth application
 * @summary Get OAuth authorization URL
 */
export const getV0UserMeOauthUrl = query(async (params: GetV0UserMeOauthUrlParams) => {
	return apiClient<GetV0UserMeOauthUrl200>({
		url: `/v0/user/me/oauth/url`,
		method: 'GET',
		params,
	});
}, 'getV0UserMeOauthUrl');

/**
 * Receives a strava webhook creation verification token
 * @summary Verify Strava Webhook
 */
export const getV0WebhookStrava = query(async (params: GetV0WebhookStravaParams) => {
	return apiClient<GetV0WebhookStrava200>({
		url: `/v0/webhook/strava`,
		method: 'GET',
		params,
	});
}, 'getV0WebhookStrava');

/**
 * Receives data from Strava subscriptions
 * @summary Receive Strava Webhook
 */
export const postV0WebhookStrava = action(async (postV0WebhookStravaBody: PostV0WebhookStravaBody) => {
	return apiClient<null>({
		url: `/v0/webhook/strava`,
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		data: postV0WebhookStravaBody,
	});
}, 'postV0WebhookStrava');
